import {useState} from "react";
import httpService from "../../services/httpService";
import Button from "react-bootstrap/Button";
import { FaSpinner } from "react-icons/fa6";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Collapse from "react-bootstrap/Collapse";
import Alert from "react-bootstrap/Alert";
import {FaRegWindowClose, FaPlay} from "react-icons/fa";

const newInsight = {
    "title": "",
    "insight": "",
    "implementation": "",
    "quote": "",
    "start_time": "0:00:10",
    "end_time": "0:32:00",
    "type": "custom"
}

const NewInsightItem = ({podcast_episode_id, podcast_club_id, onClose, onInsightSaved, onInsightClickedPlay }) => {
    const [insightLocal, setInsightLocal] = useState(newInsight);
    const [saving, setSaving] = useState(false);
    const [canSave, setCanSave] = useState(false);
    const [insightLocalErrors, setInsightLocalErrors] = useState({});
    const [errorMessage, setErrorMessage] = useState('');
    const [openDelete, setOpenDelete] = useState(false);
    const [showTimestamps, setShowTimestamps] = useState(false);

    const handleSaveInsight = async (episode) => {
        setSaving(true)
        setInsightLocalErrors({})
        setErrorMessage('')
        try {
            const payload = {
                podcast_episode_id : podcast_episode_id,
                podcast_club_id : podcast_club_id,
                ...insightLocal
            }
            const res = await httpService.post("dash/wizard/create-insight",payload);
            if(res.data.status){
                onInsightSaved()
            }
            onClose(false)
            setCanSave(false)
            setInsightLocal(newInsight)
        } catch (err) {
            console.error('Error saving insight:', err)
            setErrorMessage(err.response?.data?.message || err.message || "Error saving insight")
            setInsightLocalErrors(err.response?.data?.errors || {})
        } finally {
            setSaving(false)
        }
    }

    const handleChange = (e) => {
        if(newInsight[e.target.name] !== e.target.value){
            setInsightLocal({...insightLocal, [e.target.name] : e.target.value})
            setCanSave(true)
        } else {
            // setCanSave(false)
        }
    }

    const hmsToSeconds = (input) => {
        if (input == null) return 0;
        const s = String(input).trim();
        if (s === "") return 0;

        // Plain number (e.g., "90" or "90.5")
        if (/^\d+(\.\d+)?$/.test(s)) return parseFloat(s);

        const parts = s.split(":");
        if (parts.some(p => p === "" || isNaN(p))) return NaN;

        // Right-align to [hh, mm, ss]
        const [hh, mm, ss] = [0, 0, 0].slice(parts.length).concat(parts).map(Number);

        if (mm < 0 || mm >= 60 || ss < 0 || ss >= 60) return NaN;
        if (hh < 0) return NaN;

        return hh * 3600 + mm * 60 + ss; // supports fractional seconds in ss
    }

    const onClickPlay = () => {
        if (onInsightClickedPlay) {
            onInsightClickedPlay(hmsToSeconds(insightLocal.start_time))
        }
    }

    return(
        <div className={''}>
            <Row>
                <Col sm={12} className={'mt-0'}>
                    <Row>
                        <Col sm={6}>

                        </Col>
                        <Col sm={2} className={'align-items-end justify-content-end'}>

                            <Button
                                disabled={false}
                                onClick={() => onClose(false)}
                                className={"w-100"}
                                variant="light"
                            >
                                <FaRegWindowClose />
                            </Button>
                        </Col>
                        <Col sm={4}>
                            <Button
                                disabled={!canSave}
                                onClick={()=>handleSaveInsight()}
                                className="w-100"
                                variant="success"
                            >
                                {saving ? <FaSpinner className={"loading_spinner"} /> : 'Create'}
                            </Button>
                        </Col>
                    </Row>
                    {errorMessage && (
                        <Alert variant="danger" className="mt-3" onClose={() => setErrorMessage('')} dismissible>
                            {errorMessage}
                        </Alert>
                    )}
                </Col>
                <Col sm={12}>
                    <Form.Group className="" controlId="title">
                        <Form.Label>Title</Form.Label>
                        <Form.Control
                            name={'title'}
                            value={insightLocal.title}
                            type="text"
                            placeholder="Title"
                            onChange={handleChange}
                            isInvalid={insightLocalErrors.hasOwnProperty('title')}
                            disabled={saving}
                            className={"mb-2"}
                        />
                        <Form.Control.Feedback type="invalid">
                            {insightLocalErrors?.title ?? ""}
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className="" controlId="insight">
                        <Form.Label>Insight</Form.Label>
                        <Form.Control
                            value={insightLocal.insight}
                            name={'insight'}
                            rows={3}
                            as='textarea'
                            type="text"
                            placeholder="Insight"
                            onChange={handleChange}
                            isInvalid={insightLocalErrors.hasOwnProperty('insight')}
                            disabled={saving}
                            className={"mb-2"}
                        />
                        <Form.Control.Feedback type="invalid">
                            {insightLocalErrors?.description ?? ""}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
                <Col sm={12} className={'mt-2'}>
                    <Form.Check
                        type="switch"
                        id="timestamps-toggle"
                        label="Check to add start and end times of the episode audio"
                        checked={showTimestamps}
                        onChange={() => setShowTimestamps(!showTimestamps)}
                        className="mb-3"
                    />
                </Col>
                <Collapse in={showTimestamps}>
                    <div id="timestamps-collapse" className="w-100">
                        <Row>
                            <Col sm={8}>
                                <Row>
                                    <Col sm={6}>
                                        <Form.Group className="" controlId="start_time">
                                            <Form.Label>Start Time</Form.Label>
                                            <Form.Control
                                                value={insightLocal.start_time}
                                                name={'start_time'}
                                                step={1}
                                                type="time"
                                                onChange={handleChange}
                                                isInvalid={insightLocalErrors.hasOwnProperty('start_time')}
                                                disabled={saving}
                                                className={"mb-2"}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {insightLocalErrors?.start_time ?? ""}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>
                                    <Col sm={6}>
                                        <Form.Group className="" controlId="end_time">
                                            <Form.Label>End Time</Form.Label>
                                            <Form.Control
                                                value={insightLocal.end_time}
                                                name={'end_time'}
                                                step={1}
                                                type="time"
                                                onChange={handleChange}
                                                isInvalid={insightLocalErrors.hasOwnProperty('end_time')}
                                                disabled={saving}
                                                className={"mb-2"}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {insightLocalErrors?.end_time ?? ""}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Col>
                            <Col sm={4}>
                                <label className={'mb-2'}>Jump to this moment</label><br/>
                                <Button
                                    onClick={onClickPlay}
                                    variant="light"
                                    disabled={!insightLocal.start_time}
                                >
                                    <FaPlay />
                                </Button>
                            </Col>
                        </Row>
                    </div>
                </Collapse>
                <Col sm={12}>
                    <Form.Group className="" controlId="quote">
                        <Form.Label>A line from the episode that captures this idea</Form.Label>
                        <Form.Control
                            name={'quote'}
                            value={insightLocal.quote}
                            rows={3}
                            as='textarea'
                            type="text"
                            placeholder="A line from the episode that captures this idea"
                            onChange={handleChange}
                            isInvalid={insightLocalErrors.hasOwnProperty('quote')}
                            disabled={saving}
                            className={"mb-2"}
                        />
                        <Form.Control.Feedback type="invalid">
                            {insightLocalErrors?.quote ?? ""}
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className="" controlId="Implementation">
                        <Form.Label>How to apply this</Form.Label>
                        <Form.Control
                            value={insightLocal.implementation}
                            name={'implementation'}
                            rows={5}
                            as='textarea'
                            type="text"
                            placeholder="What should the listener try after hearing this?"
                            onChange={handleChange}
                            isInvalid={insightLocalErrors.hasOwnProperty('implementation')}
                            disabled={saving}
                            className={"mb-2"}
                        />
                        <Form.Control.Feedback type="invalid">
                            {insightLocalErrors?.implementation ?? ""}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
                <Col sm={12}>
                    <hr/>
                    <p className={'m-0'}>You can change or refine this later</p>
                </Col>
            </Row>
        </div>
    )
}

export default NewInsightItem;